<phx-select
    [items]="shopListArray()"
    [formControl]="formControl"
    [formlyAttributes]="field"
    bindLabel="label"
    bindValue="value"
    [dataTestId]="props.dataTestId"
>
    <ng-template #itemTemplate #selectedItemTemplate let-item>
        {{ item.label }}
    </ng-template>
</phx-select>
